import React, { useState } from "react";
import {
  publicPass,
  publicUser,
  saveEntityData,
} from "../utils/RequestHandler";
import { isUserLoggedIn, loginUser, logoutUser } from "../utils/AuthHandler";
import {
  Container,
  Form,
  FormWrapper,
  Input,
  PageWrapper,
  StatusMessage,
  Wrapper,
} from "../style/view.styles";
import FullButton from "../components/Buttons/FullButton";

export default function RequestDemo() {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    preferred_slot: "",
    note: "",
    status: "pending",
  });
  const [formStatus, setFormStatus] = useState({ message: "", type: "" }); // Status message and type

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isUserPublicAgent = false;
    try {
      if (!isUserLoggedIn()) {
        const publicLogin = await loginUser(publicUser, publicPass);
        if (publicLogin) isUserPublicAgent = true;
      }
      const response = await saveEntityData("demo_request", formData);
      if (response.success) {
        setFormStatus({
          message:
            "Thank you for requesting a demo. We will get back to you shortly!",
          type: "success",
        });
        setFormData({
          fullname: "",
          email: "",
          preferred_slot: "",
          note: "",
          status: "pending",
        });
      }
    } catch (error) {
      console.error("Error saving data:", error);
      setFormStatus({
        message:
          "An error occurred while submitting your request. Please try again.",
        type: "error",
      });
    } finally {
      if (isUserPublicAgent) logoutUser();
    }
  };

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <PageWrapper className="container flexCenter">
            <FormWrapper>
              <h1 className="font40 darkGreenColor extraBold">Request Demo</h1>
              <Form onSubmit={handleSubmit}>
                <Input
                  type="text"
                  id="fullname"
                  name="fullname"
                  value={formData.fullname}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full names"
                />
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email address"
                />
                <Input
                  type="datetime-local"
                  id="preferred_slot"
                  name="preferred_slot"
                  value={formData.preferred_slot}
                  onChange={handleChange}
                  required
                />
                <FullButton type="submit" title="Send Request" />
              </Form>
              {formStatus.message && (
                <StatusMessage type={formStatus.type}>
                  {formStatus.message}
                </StatusMessage>
              )}
            </FormWrapper>
          </PageWrapper>
        </Container>
      </Wrapper>
    </>
  );
}
